import * as toastr from 'toastr';
import {ACTION_TYPES, createAction} from "../actions";
import { call, put, takeEvery} from 'redux-saga/effects'
import {updateLayerByType} from "../../http/updateLayerByType";

export function* updateLayerSaga () {
    yield takeEvery(ACTION_TYPES.UPDATE_LAYER, updateLayer);
}

export function* updateLayer (action: any) {
    const payload: {type: string, layername: string} = action.payload;
    try {
        const {layername, type} = payload;
        const layer = yield call(updateLayerByType, type, layername);
        if (layer) toastr.success(`Updated layer ${layername}`);

        yield put(createAction(ACTION_TYPES.UPDATE_LAYER_SUCCESS, {
            layername, type
        }));
    } catch (error) {
        yield put(createAction(ACTION_TYPES.UPDATE_LAYER_ERROR, {error}));
    }
}
